    export function getServerMonth(date){
    let serverMonth;
    if (date.length === 8){
        serverMonth = date.toString().slice(-6, -4);;
    }else{
        serverMonth = date.toString().slice(-5, -4);;
    }
    return serverMonth;
    }

    export function getServerYear(date){
    let serverYear;
        serverYear = date.toString().slice(-4, date.length);;

    return serverYear;
    }

    export function getServerDay(date){
    let serverDay;
    if (date.length === 8){
        serverDay = date.toString().slice(-8, -6);;
    }else{
        serverDay = date.toString().slice(-7, -5);;
    }
    return serverDay;
    }

    export function getPracticasDay(date){
    let practicasDate = date.slice(-10,-8);
    return parseInt(practicasDate);
    }

    export function getPracticasMonth(date){
    let practicasMonth = date.slice(-7, -5);
    return parseInt(practicasMonth);
    }

    export function daysInMonth (month, year) {
    return new Date(year, month, 0).getDate();
    }
